{
  "version": 1,
  "asset_id": "29427213-6d5d-473f-9d0a-63c5ead3240a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/29427213-6d5d-473f-9d0a-63c5ead3240a/bypass-revision-weight-chart-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/29427213-6d5d-473f-9d0a-63c5ead3240a/bypass-revision-weight-chart-480.webp",
  "original_filename": "bypass-revision-weight-chart-480.webp",
  "size": 5514,
  "content_type": "image/webp",
  "created_at": "2026-11-01T23:24:15Z"
}
